export default "__VITE_ASSET__8NZOsKOy__"